import Service from "../AuthService";

const Hospital = {
  getAllHospitals() {
    return Service.get(`hospitals`);
  },
  filterHospitals(request) {
    // console.log(request)
    return Service.get(
      `hospitals?page=${request.page_no ||
        ""}&direction_id=${request.direction_id || ""}&name=${request.name ||
        ""}&start_date=${request.start_date ||
        ""}&end_date=${request.end_date || ""}`
    );
  },
  getHospital(id) {
    return Service.get(`hospital/${id}`);
  },
  saveHospital(data) {
    // const json = {
    //     name: data.name ? data.name : "",
    //     branch: data.branch ? data.branch : "",
    //     code: data.code ? data.code : "",
    //     phone: data.phone ? data.phone : "",
    //     address: data.address ? data.address : "",
    //     road: data.road ? data.road : "",
    //     district_code: data.district_code ? data.district_code : "",
    //     sub_district_code: data.sub_district_code
    //         ? data.sub_district_code
    //         : "",
    //     province_code: data.province_code ? data.province_code : "",
    //     postal_code: data.postal_code ? data.postal_code : "",
    //     email: data.email ? data.email : "",
    //     fax: data.fax ? data.fax : "",
    //     line_id: data.line_id ? data.line_id : "",
    //     note: data.note ? data.note : "",
    //     contact_types: data.contact_types ? data.contact_types : []
    // };
    return Service.post(`hospital`, data);
  },
  updateHospital(id, data) {
    return Service.put(`hospital/${id}`, data);
  },
  deleteHospital(id, token) {
    return Service.delete(`hospital/${id}?token=${token}`);
  },
  genCodeHospital(directionId = null) {
    let url = "code";
    if (directionId) {
      url += `?directionId=${directionId}`;
    }
    return Service.get(url);
  },
  searchHospitalName(payload) {
    return Service.post(`hospital-name-search`, payload);
  },
  getContactTypes(hospitalId) {
    return Service.get(`hospital/contact-send/${hospitalId}`);
  },
  getDirections() {
    return Service.get(`directions`);
  },
  getDirection(id) {
    return Service.get(`settings/directions/${id}`);
  },
  createDirection(payload, token) {
    return Service.post(`settings/directions?token=${token}`, payload);
  },
  updateDirection(id, payload, token) {
    return Service.put(`settings/directions/${id}?token=${token}`, payload);
  },
  deleteDirection(id, token) {
    return Service.delete(`settings/directions/${id}?token=${token}`);
  },
};

export default Hospital;
